export const frontedVersion = "5.0.23";
